import { ButtonV2 } from '@synoptic/ui-kit/button-v2/button-v2.js';
import { CustomizeIcon } from '@synoptic/ui-kit/icons/react/customize.js';
import {
  inlineCustomStreamTargets,
  inlineCustomStreamTargetsMoreLabel,
} from '@synoptic/ui-kit/stream-card-v2/inline-custom-stream-targets.js';
import { StreamQueryQuery } from '@/__generated__/graphql.ts';
import { TargetsModal } from '@/components/streams/custom-stream/targets-modal.tsx';
import {
  customStreamTargetChipV2,
  customStreamTargetsActionV2,
  customStreamTargetsChipsV2,
  customStreamTargetsCopyV2,
  customStreamTargetsLabelV2,
  customStreamTargetsMoreV2,
  customStreamTargetsV2,
} from './stream-page-v2.css.ts';

export const CustomStreamTargetsV2 = ({
  stream,
  targets,
  canEdit,
}: {
  stream: NonNullable<StreamQueryQuery['stream']>;
  targets: string[];
  canEdit: boolean;
}) => {
  const { visible, hiddenCount } = inlineCustomStreamTargets(targets);
  const moreLabel = inlineCustomStreamTargetsMoreLabel(hiddenCount);

  return (
    <div className={customStreamTargetsV2}>
      <div className={customStreamTargetsCopyV2}>
        <p className={customStreamTargetsLabelV2}>Submitted targets</p>
        <ul className={customStreamTargetsChipsV2}>
          {visible.map((target, index) => (
            <li key={`${target}-${index}`} className={customStreamTargetChipV2}>
              {target}
            </li>
          ))}
          {moreLabel ? (
            <li className={customStreamTargetsMoreV2}>{moreLabel}</li>
          ) : null}
        </ul>
      </div>
      {canEdit ? (
        <TargetsModal
          instruction={stream.customTargetsData?.targetTypeInstruction}
          maxTargets={stream.subscription?.customTargets ?? 0}
          initialTargets={targets}
          targetValidationRegex={
            stream.customTargetsData?.targetValidationRegex
          }
          customTargetsData={stream.customTargetsData}
          subscription={stream.subscription}
          refetchStreamPosts
          trigger={
            <ButtonV2
              type="button"
              variant="secondary"
              className={customStreamTargetsActionV2}
              endIcon={<CustomizeIcon />}
            >
              Edit Targets
            </ButtonV2>
          }
        />
      ) : null}
    </div>
  );
};
